'use client';

import { createContext } from 'react';

import type { DefaultTheme } from 'styled-components';

export type IconColors = DefaultTheme['kallisto']['color']['icon'];

/**
 * The active brand's icon colours as real hex values.
 *
 * The styled-components theme cannot supply them: the app's provider runs with
 * `useCssVars`, which rewrites every kallisto colour into a `var(--lmn-ds-…)`
 * reference. That is what CSS wants, but a colorize is part of an ImageKit URL,
 * and a `var()` there is rejected as an invalid transformation — the image does
 * not load at all. So the provider that owns the raw tokens hands the icon
 * colours down here, alongside the theme.
 */
export const IconColorsContext = createContext<IconColors | undefined>(undefined);
